import {
  Modal,
  Form,
  Row,
  Col,
  Button,
  Card,
  InputGroup,
} from "react-bootstrap";
import { styleHelper } from "../../utils/helpers";
import Select from "react-select";
import NumberCustomInput from "../utils/NumberCustomInput";
import { useFormik } from "formik";
import { useAuth } from "../../hooks/useAuth";
import { useMutation } from "react-query";
import * as yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";
import ExpensesSelector from "../utils/ExpensesSelector";
import { Popover } from "react-tiny-popover";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { useState } from "react";

const unitOptions = [
  // {
  //   value: "qty",
  //   label: "Units (Bags, Each)",
  //   description:
  //     "Calculated per individual item (e.g., per bag, carton, or piece).",
  // },
  {
    value: "line",
    label: "Per Purchase line entry (Truck, ATC)",
    description:
      "Triggered based on the number of line entries in a transaction (e.g., number of trucks recorded).",
  },
  // {
  //   value: "amount",
  //   label: "Total Amount",
  //   description: "Based on total value of purchases or sales.",
  // },
];

const unitOptionsClaim = [
  // {
  //   value: "qty",
  //   label: "Units (Bags, Each)",
  //   description: "Free units awarded (e.g., free bags or trucks).",
  // },
  // {
  //   value: "amount_per_qty",
  //   label: "Amount per Unit",
  //   description:
  //     "Monetary reward earned for each unit purchased (e.g., ₦50 per bag or item).",
  // },
  {
    value: "line",
    label: "Purchase line entry (Truck, ATC)",
    description: "Free transactions awarded (Truck, ATC).",
  },
  // {
  //   value: "fixed_total",
  //   label: "Fixed Amount",
  //   description: "Fixed monetary reward when threshold is met.",
  // },
];

export default function AddPromoIncentiveModal({
  setShowCreatePromoIncentiveModal,
  reloadTable,
}) {
  const { backendUrl, user: authUser } = useAuth();
  const [showJournalPopover, setShowJournalPopover] = useState(false);

  const createPromoIncentive = async payload => {
    let response = await fetch(`${backendUrl}/api/incentive/create`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    return await response.json();
  };

  const createPromoIncentiveMutation = useMutation(
    payload => createPromoIncentive(payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        formik.resetForm();
        reloadTable && reloadTable();
        setShowCreatePromoIncentiveModal(false);
      },
      onError: () => {
        toast.error("Unable to perform action");
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      Name: "",
      ThresholdBy: unitOptions[0].value,
      Threshold: "",
      ClaimBy: unitOptionsClaim[0].value,
      Claim: "",
      ExpiryDays: 90,
      incomeAccountID: "",
    },
    validationSchema: yup.object().shape({
      Name: yup.string().required("Name is required"),
      incomeAccountID: yup.string().required(),
    }),
    onSubmit: values => {
      if (!values.Threshold)
        return toast.error("Please enter a purchase requirement");
      if (!values.Claim) return toast.error("Please enter a reward value");

      const payload = {
        IncentiveType: "Promo",
        Name: values.Name,
        ThresholdBy: values.ThresholdBy,
        Threshold: values.Threshold,
        ClaimBy: values.ClaimBy,
        Claim: values.Claim,
        ExpiryDays: values.ExpiryDays,
        RegDate: moment(),
        PreparedBy: authUser.Name,
        incomeAccountID: values.incomeAccountID,
      };

      createPromoIncentiveMutation.mutate(payload);
    },
  });

  const handleSelectedAccount = account => {
    formik.setFieldValue("incomeAccountID", account?.AccountID);
    setShowJournalPopover(false);
  };

  const selectedThreshold = unitOptions.find(
    el => el.value === formik.values.ThresholdBy
  );

  const selectedClaim = unitOptionsClaim.find(
    el => el.value === formik.values.ClaimBy
  );

  return (
    <Modal
      show={true}
      onHide={() => setShowCreatePromoIncentiveModal(false)}
      centered
      size="lg"
      fullscreen={styleHelper.isMobile}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h5>Create Promo Incentive</h5>
          <p className="text-muted small mb-0 fw-normal fs-6">
            Define purchase requirement and reward
          </p>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-md-4">
        <Form noValidate onSubmit={formik.handleSubmit}>
          {/* NAME */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Name
            </Form.Label>
            <Col sm="10">
              <Form.Control
                name="Name"
                placeholder="e.g. Buy 25 Get 1 Promo"
                value={formik.values.Name}
                onChange={formik.handleChange}
                isInvalid={formik.touched.Name && !!formik.errors.Name}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.Name}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>

          {/* BUY X GET Y */}
          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold">Incentive Rule</Form.Label>

            <Card className="p-3 bg-lighter border-0">
              <div className="">
                <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
                  <span>Buy</span>

                  <div style={{ width: 120 }}>
                    <NumberCustomInput
                      value={formik.values.Threshold}
                      onValueChange={v => formik.setFieldValue("Threshold", v)}
                    />
                  </div>

                  <div style={{ minWidth: 180 }}>
                    <Select
                      value={selectedThreshold}
                      options={unitOptions}
                      onChange={({ value }) =>
                        formik.setFieldValue("ThresholdBy", value)
                      }
                      isSearchable={false}
                    />
                  </div>
                </div>

                <div className="d-flex flex-wrap align-items-center gap-3 mt-3">
                  <span>Get</span>

                  <div style={{ width: 120 }}>
                    <NumberCustomInput
                      value={formik.values.Claim}
                      onValueChange={v => formik.setFieldValue("Claim", v)}
                    />
                  </div>

                  <div style={{ minWidth: 180 }}>
                    <Select
                      value={selectedClaim}
                      options={unitOptionsClaim}
                      onChange={({ value }) =>
                        formik.setFieldValue("ClaimBy", value)
                      }
                      isSearchable={false}
                    />
                  </div>
                </div>
              </div>

              {/* LIVE PREVIEW */}
              {formik.values.Threshold && formik.values.Claim && (
                <div className="mt-3 text-success small">
                  Example: Buy {formik.values.Threshold}{" "}
                  {selectedThreshold?.label} → Get {formik.values.Claim}{" "}
                  {selectedClaim?.label}
                </div>
              )}
            </Card>
          </Form.Group>

          {/* EXPIRY */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Expiry (Days)
            </Form.Label>
            <Col sm="8">
              <NumberCustomInput
                value={formik.values.ExpiryDays}
                onValueChange={v => formik.setFieldValue("ExpiryDays", v)}
              />
              <div className="text-muted small">
                Rewards expire after this period.
              </div>
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Income Account
            </Form.Label>
            <Col sm="8">
              <InputGroup hasValidation>
                <Form.Control
                  placeholder="Select Income Account"
                  value={
                    formik.values.incomeAccountID
                      ? `${formik.values.incomeAccountID}`
                      : ""
                  }
                  onChange={() => {}}
                  readOnly
                  isInvalid={
                    formik.touched.incomeAccountID &&
                    !!formik.errors.incomeAccountID
                  }
                />
                <Popover
                  isOpen={showJournalPopover}
                  onClickOutside={() => setShowJournalPopover(false)}
                  content={() => (
                    <ExpensesSelector
                      handleSelectedExpense={handleSelectedAccount}
                      usage="chart of accounts"
                      onHide={() => setShowJournalPopover(false)}
                      Type="INCOME"
                    />
                  )}
                  position="bottom"
                >
                  <InputGroup.Text onClick={() => setShowJournalPopover(true)}>
                    <MagnifyIcon />
                  </InputGroup.Text>
                </Popover>
                <Form.Control.Feedback type="invalid">
                  {formik.errors.incomeAccountID}
                </Form.Control.Feedback>
              </InputGroup>
            </Col>
          </Form.Group>

          <hr />

          {/* HELP */}
          <div className="my-4">
            <div className="fw-semibold mb-2">How This Works</div>

            <div className="row justify-content-between">
              <div className="col">
                <p className="mb-2">Buy</p>
                {[...unitOptions].map(opt => (
                  <Card key={opt.value} className="p-3 mb-2">
                    <div className="fw-semibold">{opt.label}</div>
                    <div className="text-muted small">{opt.description}</div>
                  </Card>
                ))}
              </div>

              <div className="col">
                <p className="mb-2">Get</p>
                {[...unitOptionsClaim].map(opt => (
                  <Card key={opt.value} className="p-3 mb-2">
                    <div className="fw-semibold">{opt.label}</div>
                    <div className="text-muted small">{opt.description}</div>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="outline-primary"
          onClick={() => setShowCreatePromoIncentiveModal(false)}
        >
          Cancel
        </Button>

        <Button onClick={formik.submitForm}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
